module.exports = __webpack_public_path__ + "img/draft-green.1d668317.svg";